import { motion, AnimatePresence } from "framer-motion";
import { XCircleIcon, } from "@heroicons/react/24/outline";
import classes from "./modal.module.css";

const backdropVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
};

const modalVariants = {
  hidden: { opacity: 0, scale: 0.95, y: 20 },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: { duration: 0.2, ease: "easeOut" },
  },
  exit: {
    opacity: 0,
    scale: 0.95,
    y: 20,
    transition: { duration: 0.15 },
  },
};

export const Modal = ({ isOpen, title, children, onClose }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className={classes.backdrop}
          variants={backdropVariants}
          initial="hidden"
          animate="visible"
          exit="hidden"
          onClick={onClose}
        >
          <motion.div
            className={classes.modal}
            variants={modalVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            onClick={(e) => e.stopPropagation()}
          >
            <div className={classes.header}>
              <h3>{title}</h3>
              <button
                className={classes.closeBtn}
                onClick={onClose}
              >
               <XCircleIcon width={24} height={24} />
              </button>
            </div>

            <div className={classes.body}>{children}</div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
